<script setup lang="ts">
import { isEmpty } from 'es-toolkit/compat'

definePageMeta({
    sidebar: true,
    hidePromotions: true,
})

const { site } = useCoreConfig()

// SEO - START
const { data: pageData } = await usePageData('om-os')

const { getHead, getSeoMeta } = useStrapiSeo(
    pageData.value?.seo || {
        metaTitle: `Om ${site.name} | Danske spilleautomater med dansk licens`,
        metaDescription: `Læs mere om ${site.name}, der tilbyder unikke spilleautomater online på det danske spilmarked med en dansk licens. ${site.name} - For hyggens skyld.`
    }
)

useHead(getHead())
useSeoMeta(getSeoMeta())
// SEO - END
</script>

<template>
    <div class="om-os">
        <LazyNimbusStrapiDynamicRenderer
            v-if="!isEmpty(pageData?.dynamicContent)"
            :content="pageData?.dynamicContent"
            :max-width="1024"
        />
    </div>
</template>
